module.exports = __webpack_public_path__ + "assets/8581871710bf099a95567a4f655d4b7c.png";